import { memo, useCallback } from "react";

import { type Size as ButtonSize } from "@components/Button";
import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state";
import { PageModal } from "@root/tablescape/state";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";

import { ProductVideoModalButtonView } from "./ProductVideoModalButton.view";

type Props = {
  size?: ButtonSize;
};

const ProductVideoModalButtonBase = ({ size = "large" }: Props) => {
  const {
    productVideoModal: { sources, subtitles },
    settings: { theme },
    text: {
      textVideo: { playVideo },
    },
  } = useSectionSettings<ProductHeroSettings>();

  const handleModalButtonClick = useCallback(() => {
    TablescapeContext.emit(TablescapeEvent.TOGGLE_PAGE_MODAL, {
      ui: {
        pageModalTarget: PageModal.VIDEO_MODAL,
      },
      videoModal: {
        sources,
        subtitles,
      },
    });
  }, [sources, subtitles]);

  if (!sources.length) {
    return null;
  }

  return (
    <ProductVideoModalButtonView
      handleModalButtonClick={handleModalButtonClick}
      playVideo={playVideo}
      size={size}
      theme={theme}
    />
  );
};

export const ProductVideoModalButton = memo(ProductVideoModalButtonBase);
